import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapMutations } from 'vuex'
import * as types from '@/store/types'
@Component({
    methods: {
        ...mapMutations({
            setShowSidebar: types.SIDEBAR_VISIBLE
        })
    }
})
export default class HamburgerButton extends Vue {
    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setShowSidebar!: (show: boolean) => void

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    showSidebar() {
        this.setShowSidebar(true)
    }
}